<!-- Localized -->
<template>
    <div class="explorer">
        <div class="flex items-center justify-between">
            <div class="folderNameBreadcrumb">
                <!-- <h4 class="font-medium">Client Input</h4> -->
                <div class="flex items-center flex-wrap">
                    <div @click="onBreadcrumbClick(breadcrumb)" class="bread-crumb text-sm text-main cursor-pointer hover:text-primary-300" v-for="breadcrumb in breadcrumbs" :key="breadcrumb.id">> {{ breadcrumb.name }}&nbsp;</div>
                </div>
            </div>
            <div class="actions flex">
                 <del-button
                    v-if="!internal && checkPermission('case.generate_reports')"
                    class="mr-4"
                    :text="$t('components.filebrowser.generateReport.generate_reports')"
                    type="primary"
                    @click="handleGenerateReport({ mode: 'create', reportInfo: null })"
                />
                <div class="flex" v-if="allowActions">
                    <del-button
                        class="mr-4"
                        :text="$t('components.dashboard_components.add_folder')"
                        type="primary"
                        @click="onAdd('folder')"
                    />
                    <del-button
                        :text="$t('components.dashboard_components.add_file')"
                        type="primary"
                        @click="onAdd('file')"
                    />
                </div>
            </div>
        </div>
        <div class="mt-2 overflow-y-auto scroll-bar" style="height: calc(100% - 44px)">
            <TableLarge
                :rows="getRows" :columns="filteredColumns" 
                :filters="filtersObj" 
                @column-filter="onColumnFilter($event)" 
                @filters-clear="onClearFilter"
                :filterOptions="columnFilterOptions"
                @on-selected-rows-change="$emit('on-selected-rows-change', $event)"
                :config="{
                    'select-options': {
                        enabled: enableSelection,
                        selectOnCheckboxOnly: true,
                        readOnly: readOnly,
                        disableSelectInfo: true,
                    },
                }">
                <template #link="{ customData }">
                    <div class="flex items-center justify-between w-full gap-2">
                         <div class="flex text-main">
                            <svg  v-if="customData.type === 'directory'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 12.75V12A2.25 2.25 0 014.5 9.75h15A2.25 2.25 0 0121.75 12v.75m-8.69-6.44l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z" />
                            </svg>
                            <svg v-else xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"></path>
                            </svg>
                             
                        </div>
                        <div class="flex-1 relative w-36" v-if="editRow && selectedRow?.id === customData?.id">
                            <input type="text" class="border-b-2 w-full pr-10" v-model="editableFileName" :style="`background-color: inherit;`"/>
                            <span class="absolute right-1 top-50">{{getFileExtension}}</span>
                        </div>
                        <div class="flex-1 min-w-0 w-36 text-main cursor-pointer hover:text-primary-300" v-else>
                            <div @click="onDirectoryClick(customData)" class="truncate" :title="customData.name">{{ customData.name }}</div>
                        </div>
                        <!-- v-if="customData?.report_id" -->
                        <div class="flex gap-2 justify-end items-center" v-if="customData?.report_id">
                            <div class="flex">
                                 <font-awesome-icon
                                    v-if="editRow && selectedRow.id === customData.id"
                                    icon="save"
                                    class="text-green-600 text-lg w-5 h-5 cursor-pointer"
                                     @click="handleRenameFile(customData)"
                                />
                                <font-awesome-icon
                                    v-else
                                    icon="edit"
                                    :class="customData?.created_by === getUserDetails?.id ? 'text-blue-600' : 'text-gray-400 pointer-events-none opacity-50'"
                                    class=" text-lg w-5 h-5"
                                    @click="onEditRow(customData)"
                                /> 
                            </div>
                            <div class="flex" @click="handleReportInfo(customData)">
                                <svg data-v-45042bba="" xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 330 330" class="cursor-pointer w-5 h-5"><g data-v-45042bba="" xmlns="http://www.w3.org/2000/svg"><path data-v-45042bba="" d="M165 0C74.019 0 0 74.02 0 165.001 0 255.982 74.019 330 165 330s165-74.018 165-164.999S255.981 0 165 0zm0 300c-74.44 0-135-60.56-135-134.999S90.56 30 165 30s135 60.562 135 135.001C300 239.44 239.439 300 165 300z" fill="#0d69d5" data-original="#000000"></path><path data-v-45042bba="" d="M164.998 70c-11.026 0-19.996 8.976-19.996 20.009 0 11.023 8.97 19.991 19.996 19.991 11.026 0 19.996-8.968 19.996-19.991 0-11.033-8.97-20.009-19.996-20.009zM165 140c-8.284 0-15 6.716-15 15v90c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15v-90c0-8.284-6.716-15-15-15z" fill="#0d69d5" data-original="#000000"></path></g></svg>
                            </div>
                        </div>
                    </div>
                </template>
                <!-- <template #source="{ customData }">
                    <template v-if="customData.size">
                        {{ formatBytes(customData.size) }}
                    </template>
                </template> -->
                <template #show_info="{ customData }">
                    <div class="flex">
                    <!-- <button class="shadow border-solid border-gray-200 cursor-pointer py-2 px-2 rounded-lg text-sm h-full flex items-center bg-white text-brand" @click="onDownloadClick(customData)">
                                    <svg class="h-3 w-3 text-brand" xmlns="http://www.w3.org/2000/svg" id="Capa_1" enable-background="new 0 0 515.283 515.283" height="512" viewBox="0 0 515.283 515.283" width="512">
                                        <g>
                                            <g>
                                                <g>
                                                    <g>
                                                        <path
                                                            d="m400.775 515.283h-286.268c-30.584 0-59.339-11.911-80.968-33.54-21.628-21.626-33.539-50.382-33.539-80.968v-28.628c0-15.811 12.816-28.628 28.627-28.628s28.627 12.817 28.627 28.628v28.628c0 15.293 5.956 29.67 16.768 40.483 10.815 10.814 25.192 16.771 40.485 16.771h286.268c15.292 0 29.669-5.957 40.483-16.771 10.814-10.815 16.771-25.192 16.771-40.483v-28.628c0-15.811 12.816-28.628
                                            28.626-28.628s28.628 12.817 28.628 28.628v28.628c0 30.584-11.911 59.338-33.54 80.968-21.629 21.629-50.384 33.54-80.968 33.54zm-143.134-114.509c-3.96 
                                            0-7.73-.804-11.16-2.257-3.2-1.352-6.207-3.316-8.838-5.885-.001-.001-.001-.002-.002-.002-.019-.018-.038-.037-.057-.056-.005-.004-.011-.011-.016-.016-.016-.014-.03-.029-.045-.044-.01-.01-.019-.018-.029-.029-.01-.01-.023-.023-.032-.031-.02-.02-.042-.042-.062-.062l-114.508-114.509c-11.179-11.179-11.179-29.305 0-40.485 11.179-11.179 29.306-11.18 40.485 
                                            0l65.638 65.638v-274.409c-.001-15.811 12.815-28.627 28.626-28.627s28.628 12.816 28.628 28.627v274.408l65.637-65.637c11.178-11.179 
                                            29.307-11.179 40.485 0 11.179 11.179 11.179 29.306 0 40.485l-114.508 114.507c-.02.02-.042.042-.062.062-.011.01-.023.023-.032.031-.01.011-.019.019-.029.029-.014.016-.03.03-.044.044-.005.005-.012.012-.017.016-.018.019-.037.038-.056.056-.001 0-.001.001-.002.002-.315.307-.634.605-.96.895-2.397 
                                            2.138-5.067 3.805-7.89 4.995-.01.004-.018.008-.028.012-.011.004-.02.01-.031.013-3.412 1.437-7.158 2.229-11.091 2.229z"
                                                            fill="rgba(13, 105, 213)"
                                                        />
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                </button> -->
                    <TrashRed v-if="customData.report_id" :class="customData?.created_by === getUserDetails?.id ? 'cursor-pointer': 'custom pointer-events-none' " class="mx-auto" role="button" @click="deleteDirectory(customData)" />
                    <TrashRed v-else :class="[customData.is_custom ? 'cursor-pointer' : 'custom pointer-events-none']" class="mx-auto" role="button" @click="deleteDirectory(customData)" />
                </div>
                </template>
            </TableLarge>
        </div>
    </div>
</template>

<script>
import axios from "@/axios";
import TableLarge from "@shared/dashboard-components/table-large";
import DelButton from "@shared/components/button";
import TrashRed from "@shared/assets/svg/icon-trash-red.svg";
import { DateTime } from "luxon";
import { cloneDeep } from "lodash";
import { checkPermission } from "@shared/utils/functions";
import { mapGetters } from "vuex";
import { onlyUnique } from "@shared/plugins/utils.js";
import { uuid } from "vue-uuid";

export default {
    name: "Explorer",
    props: {
        directories: {
            type: Object,
            default: () => {},
        },
        breadcrumbs: {
            type: Array,
            default: () => [],
        },
        enableSelection: {
            type: Boolean,
            default: false,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
        isClient: {
            type: Boolean,
            default: false
        },
        internal: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        TableLarge,
        DelButton,
        TrashRed,
    },
    data() {
        return {
            columns: [
                {
                    label: this.$t('components.dashboard_components.file_name'),
                    field: "name",
                    config: {
                        filter: true,
                        type: "link",
                    },
                    // tdClass: "truncate max-w-xs",
                },
                {
                    label: this.$t('components.dashboard_components.uploaded_by'),
                    field: "user_name",
                    config: {
                        filter: true,
                        // type: "link",
                    },
                    // tdClass: "truncate max-w-xs",
                },
                {
                    label:this.$t('components.dashboard_components.uploaded_time'),
                    field: "time",
                    config: {
                        filter: true,
                        // type: "link",
                    },
                    // tdClass: "truncate max-w-xs",
                },
                {
                    label: this.$t('components.dashboard_components.date'),
                    field: "created_at",
                    config: {
                        filter: true,
                        // type: "source",
                    },
                },
                {
                    label: this.$t('components.dashboard_components.size'),
                    field: "size",
                    config: {
                        filter: true,
                        type: "source",
                    },
                },
                 {
                    label: 'Status',
                    field: "state",
                    config: {
                        filter: true,
                        type: "source",
                    },
                },
                {
                    label: "Actions",
                    field: "actions",
                    config: {
                        filter: false,
                        type: "show_info",
                    },
                },
            ],
            filtersObj: null,
            selectedRow: null,
            editRow: false,
            editableFileName: "",
        };
    },
    computed: {
        ...mapGetters({getUserDetails: 'getUserDetails'}),
        filteredColumns() {
            return this.readOnly ? this.columns.filter((col) => col.config.type !== 'show_info') : this.columns;
        },
        getFolderPermission() {
            if(this?.isClient) {
                return true;
            } else {
                return this.checkPermission('case.actions_external')
            }
        },
        getRows() {
            let content = this.directories?.content ?? [];
            content = cloneDeep(content);
            content = content.map((directory) => {
                let obj = directory;
                console.log(directory)
                // if (directory.created_at) {
                //     obj.created_at = DateTime.fromJSDate(new Date(directory.created_at)).toFormat("dd LLLL, yyyy");
                // }
                if (directory.size) {
                    obj.size = this.formatBytes(directory.size);
                }
                if (directory.created_at) {
                    const rawTimestamp = directory.created_at;
                    console.log(rawTimestamp)

                    // Trim to milliseconds (3 digits) to make it compatible with JavaScript Date
                    const fixedTimestamp = rawTimestamp.replace(/^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2})\.(\d{3})\d{3}$/, '$1.$2');

                    const date = new Date(fixedTimestamp);

                    // Extract and format the time
                    const timeString = date.toTimeString().split(' ')[0]; // "09:46:02"
                    obj.time = timeString

                    console.log(timeString);
                }
                if (directory.created_at) {
                    obj.created_at = DateTime.fromJSDate(new Date(directory.created_at)).toFormat("dd LLLL, yyyy");
                }
                if (directory.type === 'directory') {
                    obj.state = directory.state === 'NA' ? '' : directory.state;
                }
                return obj;
            });
            if (this.filtersObj) {
                content = content.filter((cont) => {
                    const objKey = Object.keys(this.filtersObj)[0];
                    return cont[objKey] === this.filtersObj[objKey].name;
                });
            }
            return content;
        },
        allowActions() {
            // here readOnly depend on - checkpermission('case.action_external')
            return this.directories.is_insert && !this.readOnly && this.getFolderPermission;
        },
        getFileExtension() {
            // return "." + this.selectedRow?.name?.slice((this.selectedRow?.name?.lastIndexOf('.') - 1 >>> 0) + 2)
            const index = this.selectedRow?.name?.lastIndexOf('.');
                return index > 0 && index < this.selectedRow?.name?.length - 1
                    ? this.selectedRow?.name?.slice(index)
                    : '';
            },

        columnFilterOptions() {
            return this.getFilterOptions(this.columns, this.getRows);
        },

        
    },
    methods: {
        checkPermission,
         getFilterOptions(columns, rows) {
            return columns.reduce((result, curr) => {
                result[curr.field] = rows
                .filter((row) => row[curr.field])
                .map((row) => row[curr.field])
                .filter(onlyUnique)
                .map((el) => ({ id: uuid.v4(), name: el }));
                return result;
            }, {});
        },
        async handleRenameFile(file) {
            try {
                this.editRow = false;
                if(file.name?.toString().toLowerCase().trim() === (this.editableFileName + this.getFileExtension).toString().toLowerCase().trim()) return;
                if(!this.editableFileName) {
                    this.$toast.error(this.$t("components.filebrowser.generateReport.file_name_required"));
                    return;
                }
                // Check if file name already exists
                if(this.getAllFileNames().includes((this.editableFileName + this.getFileExtension).toString().trim())) {
                    this.$toast.error(this.$t("components.filebrowser.generateReport.file_name_already_exists"));
                    return;
                }
                const response = await axios.put(`case-file-manager/case-entity-file/${file.file_id}`, {
                    name: this.editableFileName?.trim() + this.getFileExtension,
                });
                if(response.status === 200) {
                    this.$toast.success(this.$t("components.filebrowser.generateReport.file_rename_success"));
                    this.$emit("fetchFileManagerData")
                }
            } catch (error) {
                 this.$toast.error(error?.response?.data?.message || this.$t("general.default_error"));
                console.error("Error renaming file:", error);
            }
        },
        onEditRow(row) {
            this.selectedRow = row;
            this.editRow = true;
            let lastDotIndex = row.name?.lastIndexOf('.') ?? -1;
            let nameWithoutExtension = (lastDotIndex > 0) ? row.name.substring(0, lastDotIndex) : row.name;
            this.editableFileName = nameWithoutExtension
        },
        getAllFileNames() {
            //  && row?.report_id != null
            return this.getRows
                .filter(row => row.type !== 'directory')
                .map(row => row.name) || [];
        },
        async handleReportInfo(row) {
            
            try {
                this.editRow = false;
                this.selectedRow = null;
                // fetch report info
                let reportInfo = null;
                reportInfo = await this.fetchReportInfo(row);
                this.handleGenerateReport({ mode: 'view', reportInfo });
            } catch(error) {
                console.error("Error handling report info:", error);
            }
            // const reportInfo = await this.fetchReportInfo(row)
            
        },
        async fetchReportInfo(row) {
            try {
                const { data } = await axios.get(`report-builder/case/${this.$route?.query?.caseid}/report/${row.report_id}`);
                console.log("reportInfo", data);
                return data;
            } catch (error) {
                console.error("Error fetching report info:", error);
            }
        },
        onAdd(type) {
            this.onClearFilter();
            this.$emit(`on-add`, type);
        },
        handleGenerateReport({ mode, reportInfo }) {
            this.editRow = false;
            this.selectedRow = null;
            const existingFileName =  this.getAllFileNames();
            this.$emit("on-generate-report", { mode, reportInfo, existingFileName });
        },
        onDirectoryClick(directory) {
            this.onClearFilter();
            this.$emit("on-directory-click", directory);
        },
        onDownloadClick(directory) {
            this.onClearFilter();
            this.$emit("on-download-click", directory)
        },
        onBreadcrumbClick(breadcrumb) {
            this.onClearFilter();
            this.$emit("on-breadcrumb-click", breadcrumb);
        },
        deleteDirectory(content) {
            if( content?.report_id ) {
                this.$emit("on-delete-directory", content);
                return;
            } else if (content.is_custom) {
                this.onClearFilter();
                this.$emit("on-delete-directory", content);
                return;
            }
        },
        formatBytes(bytes, decimals = 2) {
            if (!+bytes) return "0 Bytes";

            const k = 1024;
            const dm = decimals < 0 ? 0 : decimals;
            const sizes = ["Bytes", "KB", "MB", "GB"];

            const i = Math.floor(Math.log(bytes) / Math.log(k));

            return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
        },
        onColumnFilter({ columnFilters }) {
            this.filtersObj = columnFilters;
        },
        onClearFilter() {
            this.filtersObj = null;
        },
        onGenerateReport() {
            // this.onClearFilter();
            // this.$emit("on-generate-report");
        },
    },
};
</script>

<style lang="scss" scoped>
.custom {
    path {
        fill: gray;
    }
}

.folderNameBreadcrumb {
    width: 70%;
}
</style>
